import { useTheme, Toolbar, AppBar } from '@mui/material';
import { RedocStandalone } from 'redoc';
import './docs.css';
import HeaderDocs from './HeaderDocs';
import { useMemo } from 'react';
import { APP_DOMAIN } from 'config';

// ==============================|| PRODUCT LIST ||============================== //

const DocsPage = () => {
    const theme = useTheme();

    const header = useMemo(
        () => (
            <Toolbar>
                <HeaderDocs />
            </Toolbar>
        ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );
    return (
        <>
            <AppBar enableColorOnDark position="sticky" color="inherit" sx={{ bgcolor: theme.palette.background.default }}>
                {header}
            </AppBar>
            <RedocStandalone
                spec={{
                    swagger: '2.0',
                    info: {
                        description: 'Aqui encontrarás la documentación para invocar los servicios de styrk.',
                        version: '1.0',
                        title: 'Styrk Catalog REST API',
                        termsOfService: 'Terms of service',
                        contact: { name: 'Vinneren', url: 'www.vinneren.com.mx', email: 'contacto@vinneren.com.mx' },
                        license: { name: 'License of API', url: 'API license URL' }
                    },
                    host: APP_DOMAIN,
                    basePath: '/',
                    tags: [
                        { name: 'active-fields-product-controller', description: 'Active Fields Product Controller' },
                        { name: 'additional-fields-controller', description: 'Additional Fields Controller' },
                        { name: 'approval-product-controller', description: 'Approval Product Controller' },
                        { name: 'basic-error-controller', description: 'Basic Error Controller' },
                        { name: 'brand-controller', description: 'Brand Controller' },
                        { name: 'carga-masiva-controller', description: 'Carga Masiva Controller' },
                        { name: 'category-controller', description: 'Category Controller' },
                        { name: 'change-log-product-controller', description: 'Change Log Product Controller' },
                        { name: 'change-log-product-multi-controller', description: 'Change Log Product Multi Controller' },
                        { name: 'common-rest', description: 'Common Rest' },
                        { name: 'health-controller', description: 'Health Controller' },
                        { name: 'images-controller', description: 'Images Controller' },
                        { name: 'inventory-controller', description: 'Inventory Controller' },
                        { name: 'liveness-controller', description: 'Liveness Controller' },
                        { name: 'login-controller', description: 'Login Controller' },
                        { name: 'menu-controller', description: 'Menu Controller' },
                        { name: 'merchant-controller', description: 'Merchant Controller' },
                        { name: 'price-controller', description: 'Price Controller' },
                        { name: 'price-multi-controller', description: 'Price Multi Controller' },
                        { name: 'product-controller', description: 'Product Controller' },
                        { name: 'product-multicatalog-controller', description: 'Product Multicatalog Controller' },
                        { name: 'profile-controller', description: 'Profile Controller' },
                        { name: 'specification-controller', description: 'Specification Controller' },
                        { name: 'status-approval-controller', description: 'Status Approval Controller' },
                        { name: 'styrk-link-variant-controller', description: 'Styrk Link Variant Controller' },
                        { name: 'styrk-link-variant-multicatalog-controller', description: 'Styrk Link Variant Multicatalog Controller' },
                        { name: 'supplier-controller', description: 'Supplier Controller' },
                        { name: 'trade-policies-controller', description: 'Trade Policies Controller' },
                        { name: 'user-controller', description: 'User Controller' },
                        { name: 'warehouse-controller', description: 'Warehouse Controller' }
                    ],
                    paths: {
                        '/': {
                            get: {
                                tags: ['liveness-controller'],
                                summary: 'liveness',
                                operationId: 'livenessUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { type: 'string' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/error': {
                            get: {
                                tags: ['basic-error-controller'],
                                summary: 'errorHtml',
                                operationId: 'errorHtmlUsingGET',
                                produces: ['text/html'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/ModelAndView' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            },
                            head: {
                                tags: ['basic-error-controller'],
                                summary: 'errorHtml',
                                operationId: 'errorHtmlUsingHEAD',
                                consumes: ['application/json'],
                                produces: ['text/html'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/ModelAndView' } },
                                    '204': { description: 'No Content' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            },
                            post: {
                                tags: ['basic-error-controller'],
                                summary: 'errorHtml',
                                operationId: 'errorHtmlUsingPOST',
                                consumes: ['application/json'],
                                produces: ['text/html'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/ModelAndView' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            },
                            put: {
                                tags: ['basic-error-controller'],
                                summary: 'errorHtml',
                                operationId: 'errorHtmlUsingPUT',
                                consumes: ['application/json'],
                                produces: ['text/html'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/ModelAndView' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            },
                            delete: {
                                tags: ['basic-error-controller'],
                                summary: 'errorHtml',
                                operationId: 'errorHtmlUsingDELETE',
                                produces: ['text/html'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/ModelAndView' } },
                                    '204': { description: 'No Content' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            },
                            options: {
                                tags: ['basic-error-controller'],
                                summary: 'errorHtml',
                                operationId: 'errorHtmlUsingOPTIONS',
                                consumes: ['application/json'],
                                produces: ['text/html'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/ModelAndView' } },
                                    '204': { description: 'No Content' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            },
                            patch: {
                                tags: ['basic-error-controller'],
                                summary: 'errorHtml',
                                operationId: 'errorHtmlUsingPATCH',
                                consumes: ['application/json'],
                                produces: ['text/html'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/ModelAndView' } },
                                    '204': { description: 'No Content' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/additionalFields/list': {
                            get: {
                                tags: ['additional-fields-controller'],
                                summary: 'listAdditionalFields',
                                operationId: 'listAdditionalFieldsUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/additionalFields/product': {
                            post: {
                                tags: ['additional-fields-controller'],
                                summary: 'saveProductAdditionalFields',
                                operationId: 'saveProductAdditionalFieldsUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'additionalField',
                                        description: 'additionalField',
                                        required: true,
                                        schema: { $ref: '#/definitions/AdditionalField' }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            },
                            put: {
                                tags: ['additional-fields-controller'],
                                summary: 'updateProductAdditionalFields',
                                operationId: 'updateProductAdditionalFieldsUsingPUT',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'additionalField',
                                        description: 'additionalField',
                                        required: true,
                                        schema: { $ref: '#/definitions/AdditionalField' }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/additionalFields/product/{id}': {
                            delete: {
                                tags: ['additional-fields-controller'],
                                summary: 'deleteProductAdditionalField',
                                operationId: 'deleteProductAdditionalFieldUsingDELETE',
                                produces: ['*/*'],
                                parameters: [
                                    { name: 'id', in: 'path', description: 'id', required: true, type: 'integer', format: 'int32' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '204': { description: 'No Content' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/additionalFields/sku': {
                            post: {
                                tags: ['additional-fields-controller'],
                                summary: 'saveSkuAdditionalFields',
                                operationId: 'saveSkuAdditionalFieldsUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'additionalField',
                                        description: 'additionalField',
                                        required: true,
                                        schema: { $ref: '#/definitions/AdditionalField' }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            },
                            put: {
                                tags: ['additional-fields-controller'],
                                summary: 'updateSkuAdditionalFields',
                                operationId: 'updateSkuAdditionalFieldsUsingPUT',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'additionalField',
                                        description: 'additionalField',
                                        required: true,
                                        schema: { $ref: '#/definitions/AdditionalField' }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/additionalFields/sku/{id}': {
                            delete: {
                                tags: ['additional-fields-controller'],
                                summary: 'deleteSkuAdditionalField',
                                operationId: 'deleteSkuAdditionalFieldUsingDELETE',
                                produces: ['*/*'],
                                parameters: [
                                    { name: 'id', in: 'path', description: 'id', required: true, type: 'integer', format: 'int32' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '204': { description: 'No Content' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/brand/create': {
                            post: {
                                tags: ['brand-controller'],
                                summary: 'createBrand',
                                operationId: 'createBrandUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'brandCreate',
                                        description: 'brandCreate',
                                        required: true,
                                        schema: { $ref: '#/definitions/VtexBrandDTO' }
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/brand/save-multicatalog': {
                            post: {
                                tags: ['brand-controller'],
                                summary: 'createBrand',
                                operationId: 'createBrandUsingPOST_1',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'brandCreate',
                                        description: 'brandCreate',
                                        required: true,
                                        schema: { type: 'array', items: { $ref: '#/definitions/FormBrandMulticatalogDTO' } }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/brand/search': {
                            post: {
                                tags: ['brand-controller'],
                                summary: 'searchAllBrand',
                                operationId: 'searchAllBrandUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'brandSearch',
                                        description: 'brandSearch',
                                        required: true,
                                        schema: { $ref: '#/definitions/BrandSearchDTO' }
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/brand/search-multicatalog': {
                            post: {
                                tags: ['brand-controller'],
                                summary: 'searchAllBrandMulticatalog',
                                operationId: 'searchAllBrandMulticatalogUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'brandSearch',
                                        description: 'brandSearch',
                                        required: true,
                                        schema: { $ref: '#/definitions/BrandSearchDTO' }
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/category/create': {
                            post: {
                                tags: ['category-controller'],
                                summary: 'createCategory',
                                operationId: 'createCategoryUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'body',
                                        description: 'body',
                                        required: true,
                                        schema: { $ref: '#/definitions/VtexCategoryDTO' }
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/category/fillcategories': {
                            get: {
                                tags: ['category-controller'],
                                summary: 'fillcategories',
                                operationId: 'fillcategoriesUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/category/get': {
                            get: {
                                tags: ['category-controller'],
                                summary: 'findCategoryById',
                                operationId: 'findCategoryByIdUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'categoryId',
                                        in: 'query',
                                        description: 'categoryId',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/category/getcategorybyname': {
                            get: {
                                tags: ['category-controller'],
                                summary: 'findCategoryByName',
                                operationId: 'findCategoryByNameUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    { name: 'categoryName', in: 'query', description: 'categoryName', required: true, type: 'string' },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/category/save-multicatalog': {
                            post: {
                                tags: ['category-controller'],
                                summary: 'createCategoryMulticatalog',
                                operationId: 'createCategoryMulticatalogUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'formCategories',
                                        description: 'formCategories',
                                        required: true,
                                        schema: { type: 'array', items: { $ref: '#/definitions/FormCategoryMulticatalogDTO' } }
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/category/search': {
                            get: {
                                tags: ['category-controller'],
                                summary: 'searchAllCategories',
                                operationId: 'searchAllCategoriesUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/category/search-multicatalog': {
                            get: {
                                tags: ['category-controller'],
                                summary: 'searchAllCategoriesMulticatalog',
                                operationId: 'searchAllCategoriesMulticatalogUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/category/update': {
                            post: {
                                tags: ['category-controller'],
                                summary: 'updateCategory',
                                operationId: 'updateCategoryUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'body',
                                        description: 'body',
                                        required: true,
                                        schema: { $ref: '#/definitions/VtexCategoryDTO' }
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/forgotpass': {
                            post: {
                                tags: ['login-controller'],
                                summary: 'forgotPassUser',
                                operationId: 'forgotPassUserUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'login',
                                        description: 'login',
                                        required: true,
                                        schema: { $ref: '#/definitions/LoginDTO' }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/images/delete/file': {
                            delete: {
                                tags: ['images-controller'],
                                summary: 'deleteImage',
                                operationId: 'deleteImageUsingDELETE',
                                produces: ['*/*'],
                                parameters: [
                                    { name: 'idImage', in: 'query', description: 'idImage', required: true, type: 'string' },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'idSKU', in: 'query', description: 'idSKU', required: true, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '204': { description: 'No Content' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/images/save/file': {
                            post: {
                                tags: ['images-controller'],
                                summary: 'createImage',
                                operationId: 'createImageUsingPOST',
                                consumes: ['multipart/form-data'],
                                produces: ['*/*'],
                                parameters: [
                                    { name: 'file', in: 'formData', description: 'file', required: true, type: 'file' },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'imageName', in: 'query', description: 'imageName', required: true, type: 'string' },
                                    { name: 'isMain', in: 'query', description: 'isMain', required: true, type: 'boolean' },
                                    { name: 'label', in: 'query', description: 'label', required: true, type: 'string' },
                                    { name: 'skuId', in: 'query', description: 'skuId', required: true, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/images/update/file': {
                            post: {
                                tags: ['images-controller'],
                                summary: 'updateImage',
                                operationId: 'updateImageUsingPOST',
                                consumes: ['multipart/form-data'],
                                produces: ['*/*'],
                                parameters: [
                                    { name: 'file', in: 'formData', description: 'file', required: true, type: 'file' },
                                    { name: 'id', in: 'query', description: 'id', required: true, type: 'integer', format: 'int32' },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'imageName', in: 'query', description: 'imageName', required: true, type: 'string' },
                                    { name: 'isMain', in: 'query', description: 'isMain', required: true, type: 'boolean' },
                                    { name: 'label', in: 'query', description: 'label', required: true, type: 'string' },
                                    { name: 'skuId', in: 'query', description: 'skuId', required: true, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/info': {
                            get: {
                                tags: ['login-controller'],
                                summary: 'getInfo',
                                operationId: 'getInfoUsingGET_1',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { type: 'string' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/inventory': {
                            get: {
                                tags: ['inventory-controller'],
                                summary: 'searchInventory',
                                operationId: 'searchInventoryUsingGET',
                                produces: ['*/*'],
                                parameters: [{ name: 'refId', in: 'query', description: 'refId', required: false, type: 'string' }],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            },
                            post: {
                                tags: ['inventory-controller'],
                                summary: 'saveInventoryList',
                                operationId: 'saveInventoryListUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'inventoryList',
                                        description: 'inventoryList',
                                        required: true,
                                        schema: { type: 'array', items: { $ref: '#/definitions/InventoryDTO' } }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/linkvariant/getProductFacetAsociation': {
                            get: {
                                tags: ['styrk-link-variant-controller'],
                                summary: 'getProductFacetAsociation',
                                operationId: 'getProductFacetAsociationUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'productId',
                                        in: 'query',
                                        description: 'productId',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/linkvariant/getSkuVariantAsociation': {
                            get: {
                                tags: ['styrk-link-variant-controller'],
                                summary: 'getSkuVariantAsociation',
                                operationId: 'getSkuVariantAsociationUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'sku', in: 'query', description: 'sku', required: true, type: 'integer', format: 'int32' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/linkvariant/product': {
                            post: {
                                tags: ['styrk-link-variant-controller'],
                                summary: 'linkVariantProduct',
                                operationId: 'linkVariantProductUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'body',
                                        description: 'body',
                                        required: true,
                                        schema: { type: 'array', items: { $ref: '#/definitions/LinkValSku' } }
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'productId',
                                        in: 'query',
                                        description: 'productId',
                                        required: true,
                                        type: 'integer',
                                        format: 'int64'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/linkvariant/sku': {
                            post: {
                                tags: ['styrk-link-variant-controller'],
                                summary: 'linkVariantSku',
                                operationId: 'linkVariantSkuUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'body',
                                        description: 'body',
                                        required: true,
                                        schema: { type: 'array', items: { $ref: '#/definitions/LinkValSku' } }
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'skuId', in: 'query', description: 'skuId', required: true, type: 'integer', format: 'int64' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/login': {
                            post: {
                                tags: ['login-controller'],
                                summary: 'createLoginUser',
                                operationId: 'createLoginUserUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'login',
                                        description: 'login',
                                        required: true,
                                        schema: { $ref: '#/definitions/LoginDTO' }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/massive/search': {
                            get: {
                                tags: ['carga-masiva-controller'],
                                summary: 'searchProducts',
                                operationId: 'searchProductsUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'eans',
                                        in: 'query',
                                        description: 'eans',
                                        required: false,
                                        type: 'array',
                                        items: { type: 'string' },
                                        collectionFormat: 'multi'
                                    },
                                    {
                                        name: 'idBrand',
                                        in: 'query',
                                        description: 'idBrand',
                                        required: false,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idCategory',
                                        in: 'query',
                                        description: 'idCategory',
                                        required: false,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'idSKU', in: 'query', description: 'idSKU', required: false, type: 'string' },
                                    { name: 'page', in: 'query', description: 'page', required: false, type: 'integer', format: 'int32' },
                                    { name: 'productName', in: 'query', description: 'productName', required: false, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/SearchStatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/menu/search': {
                            get: {
                                tags: ['menu-controller'],
                                summary: 'getMenu',
                                operationId: 'getMenuUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/merchant/update': {
                            post: {
                                tags: ['merchant-controller'],
                                summary: 'updateMerchant',
                                operationId: 'updateMerchantUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        in: 'body',
                                        name: 'merchantVO',
                                        description: 'merchantVO',
                                        required: true,
                                        schema: { $ref: '#/definitions/MerchantVO' }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/merchant/validateinstalltoken': {
                            get: {
                                tags: ['merchant-controller'],
                                summary: 'validateInstallToken',
                                operationId: 'validateInstallTokenUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    { name: 'installToken', in: 'query', description: 'installToken', required: true, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/multicatalog/linkvariant/getProductFacetAssociation': {
                            get: {
                                tags: ['styrk-link-variant-multicatalog-controller'],
                                summary: 'getProductFacetAsociation',
                                operationId: 'getProductFacetAsociationUsingGET_1',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'productId',
                                        in: 'query',
                                        description: 'productId',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/multicatalog/product/approvalprofile': {
                            get: {
                                tags: ['product-multicatalog-controller'],
                                summary: 'getCycleApprovalByMerchant',
                                operationId: 'getCycleApprovalByMerchantUsingGET_1',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/multicatalog/product/changelog': {
                            post: {
                                tags: ['change-log-product-multi-controller'],
                                summary: 'searchProductDetailBySkuIdMulticatalog',
                                operationId: 'searchProductDetailBySkuIdMulticatalogUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'changeLonge',
                                        description: 'changeLonge',
                                        required: true,
                                        schema: { $ref: '#/definitions/ChangeLogDTO' }
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/multicatalog/product/detail/product': {
                            get: {
                                tags: ['product-multicatalog-controller'],
                                summary: 'searchProductDetailMulticatalogByProdId',
                                operationId: 'searchProductDetailMulticatalogByProdIdUsingGET_1',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'idProd', in: 'query', description: 'idProd', required: true, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/multicatalog/product/lifecycleapproval': {
                            get: {
                                tags: ['product-multicatalog-controller'],
                                summary: 'searchLifecycleApproval',
                                operationId: 'searchLifecycleApprovalUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'idProd', in: 'query', description: 'idProd', required: false, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/multicatalog/product/save/approve': {
                            post: {
                                tags: ['approval-product-controller'],
                                summary: 'approveProduct',
                                operationId: 'approveProductUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'products',
                                        description: 'products',
                                        required: true,
                                        schema: { type: 'array', items: { $ref: '#/definitions/ApproveProductMulticatalog' } }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/multicatalog/product/search': {
                            get: {
                                tags: ['product-multicatalog-controller'],
                                summary: 'searchAllProductMulticatalog',
                                operationId: 'searchAllProductMulticatalogUsingGET_1',
                                produces: ['*/*'],
                                parameters: [
                                    { name: 'ean', in: 'query', description: 'ean', required: false, type: 'string' },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'idProd', in: 'query', description: 'idProd', required: false, type: 'string' },
                                    { name: 'idSKU', in: 'query', description: 'idSKU', required: false, type: 'string' },
                                    { name: 'isActive', in: 'query', description: 'isActive', required: false, type: 'boolean' },
                                    { name: 'limit', in: 'query', description: 'limit', required: false, type: 'integer', format: 'int32' },
                                    { name: 'page', in: 'query', description: 'page', required: true, type: 'integer', format: 'int32' },
                                    { name: 'productName', in: 'query', description: 'productName', required: false, type: 'string' },
                                    { name: 'productRefID', in: 'query', description: 'productRefID', required: false, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/SearchStatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/multicatalog/searchpricecatalog': {
                            get: {
                                tags: ['price-multi-controller'],
                                summary: 'searchPriceCatalog',
                                operationId: 'searchPriceCatalogUsingGET_1',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/multicatalog/supplier/search': {
                            get: {
                                tags: ['supplier-controller'],
                                summary: 'searchAllProvidersMulticatalog',
                                operationId: 'searchAllProvidersMulticatalogUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: false,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idProvider',
                                        in: 'query',
                                        description: 'idProvider',
                                        required: false,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'nameProvider', in: 'query', description: 'nameProvider', required: false, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/multicatalog/tradepolicies': {
                            get: {
                                tags: ['trade-policies-controller'],
                                summary: 'searchTradePoliciesMulticatalog',
                                operationId: 'searchTradePoliciesMulticatalogUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'idPolicy', in: 'query', description: 'idPolicy', required: false, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/multicatalog/warehouses': {
                            get: {
                                tags: ['warehouse-controller'],
                                summary: 'searchWarehousesMulti',
                                operationId: 'searchWarehousesMultiUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: false,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'warehouses', in: 'query', description: 'warehouses', required: false, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/price': {
                            get: {
                                tags: ['price-controller'],
                                summary: 'searchPrice',
                                operationId: 'searchPriceUsingGET',
                                produces: ['*/*'],
                                parameters: [{ name: 'refId', in: 'query', description: 'refId', required: false, type: 'string' }],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            },
                            post: {
                                tags: ['price-controller'],
                                summary: 'savePriceList',
                                operationId: 'savePriceListUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'priceList',
                                        description: 'priceList',
                                        required: true,
                                        schema: { type: 'array', items: { $ref: '#/definitions/PriceDTO' } }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/activeFields': {
                            get: {
                                tags: ['active-fields-product-controller'],
                                summary: 'searchActiveFieldsProviderProfile',
                                operationId: 'searchActiveFieldsProviderProfileUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idProvider',
                                        in: 'query',
                                        description: 'idProvider',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/approval': {
                            get: {
                                tags: ['approval-product-controller'],
                                summary: 'searchApprovalProduct',
                                operationId: 'searchApprovalProductUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'prodId', in: 'query', description: 'prodId', required: true, type: 'string' },
                                    { name: 'skuId', in: 'query', description: 'skuId', required: true, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/approval-multicatalog': {
                            get: {
                                tags: ['approval-product-controller'],
                                summary: 'searchApprovalProductMulticatalog',
                                operationId: 'searchApprovalProductMulticatalogUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'prodId',
                                        in: 'query',
                                        description: 'prodId',
                                        required: false,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'skuId', in: 'query', description: 'skuId', required: false, type: 'integer', format: 'int32' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/approvalprofile': {
                            get: {
                                tags: ['product-controller'],
                                summary: 'getCycleApprovalByMerchant',
                                operationId: 'getCycleApprovalByMerchantUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/changelog': {
                            post: {
                                tags: ['change-log-product-controller'],
                                summary: 'searchProductDetailBySkuId',
                                operationId: 'searchProductDetailBySkuIdUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'changeLonge',
                                        description: 'changeLonge',
                                        required: true,
                                        schema: { $ref: '#/definitions/ChangeLogDTO' }
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/detail/product': {
                            get: {
                                tags: ['product-controller'],
                                summary: 'searchProductDetailByProdId',
                                operationId: 'searchProductDetailByProdIdUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'idProd', in: 'query', description: 'idProd', required: true, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/detail/product-multicatalog': {
                            get: {
                                tags: ['product-controller'],
                                summary: 'searchProductDetailMulticatalogByProdId',
                                operationId: 'searchProductDetailMulticatalogByProdIdUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'idProd', in: 'query', description: 'idProd', required: true, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/detail/productSkus': {
                            get: {
                                tags: ['product-controller'],
                                summary: 'searchProductSku',
                                operationId: 'searchProductSkuUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idProd',
                                        in: 'query',
                                        description: 'idProd',
                                        required: false,
                                        type: 'integer',
                                        format: 'int64'
                                    },
                                    {
                                        name: 'merchantId',
                                        in: 'query',
                                        description: 'merchantId',
                                        required: false,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'productReference',
                                        in: 'query',
                                        description: 'productReference',
                                        required: false,
                                        type: 'string'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/detail/sku': {
                            get: {
                                tags: ['product-controller'],
                                summary: 'searchSkuDetailBySkuId',
                                operationId: 'searchSkuDetailBySkuIdUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'idSKU', in: 'query', description: 'idSKU', required: true, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/detail/sku-multicatalog': {
                            get: {
                                tags: ['product-controller'],
                                summary: 'searchSkuDetailMulticatalogBySkuId',
                                operationId: 'searchSkuDetailMulticatalogBySkuIdUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'idSKU', in: 'query', description: 'idSKU', required: true, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/lifecycleapproval': {
                            get: {
                                tags: ['product-controller'],
                                summary: 'searchLifcycleApproval',
                                operationId: 'searchLifcycleApprovalUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'idProd', in: 'query', description: 'idProd', required: false, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/rejectcatalog': {
                            get: {
                                tags: ['approval-product-controller'],
                                summary: 'searchRejectReasons',
                                operationId: 'searchRejectReasonsUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/rejectcatalog-multicatalog': {
                            get: {
                                tags: ['approval-product-controller'],
                                summary: 'searchRejectReasonsMulticatalog',
                                operationId: 'searchRejectReasonsMulticatalogUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/save/approval': {
                            post: {
                                tags: ['approval-product-controller'],
                                summary: 'saveApprovalProduct',
                                operationId: 'saveApprovalProductUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'approvalProductVO',
                                        description: 'approvalProductVO',
                                        required: true,
                                        schema: { $ref: '#/definitions/SaveLifecycleApprovalProductVO' }
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/save/product': {
                            post: {
                                tags: ['product-controller'],
                                summary: 'createProduct',
                                operationId: 'createProductUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'product',
                                        description: 'product',
                                        required: true,
                                        schema: { $ref: '#/definitions/VtexProductSkuSearchDetailVO' }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/search': {
                            get: {
                                tags: ['product-controller'],
                                summary: 'searchAllProduct',
                                operationId: 'searchAllProductUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    { name: 'ean', in: 'query', description: 'ean', required: false, type: 'string' },
                                    {
                                        name: 'idApprovalStatus',
                                        in: 'query',
                                        description: 'idApprovalStatus',
                                        required: false,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'idProd', in: 'query', description: 'idProd', required: false, type: 'string' },
                                    { name: 'idSKU', in: 'query', description: 'idSKU', required: false, type: 'string' },
                                    { name: 'isActive', in: 'query', description: 'isActive', required: false, type: 'boolean' },
                                    { name: 'page', in: 'query', description: 'page', required: true, type: 'integer', format: 'int32' },
                                    { name: 'productName', in: 'query', description: 'productName', required: false, type: 'string' },
                                    { name: 'productRefID', in: 'query', description: 'productRefID', required: false, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/SearchStatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/search-multicatalog': {
                            get: {
                                tags: ['product-controller'],
                                summary: 'searchAllProductMulticatalog',
                                operationId: 'searchAllProductMulticatalogUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    { name: 'ean', in: 'query', description: 'ean', required: false, type: 'string' },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'idProd', in: 'query', description: 'idProd', required: false, type: 'string' },
                                    { name: 'idSKU', in: 'query', description: 'idSKU', required: false, type: 'string' },
                                    { name: 'isActive', in: 'query', description: 'isActive', required: false, type: 'boolean' },
                                    { name: 'page', in: 'query', description: 'page', required: true, type: 'integer', format: 'int32' },
                                    { name: 'productName', in: 'query', description: 'productName', required: false, type: 'string' },
                                    { name: 'productRefID', in: 'query', description: 'productRefID', required: false, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/SearchStatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/product/searchall': {
                            get: {
                                tags: ['product-controller'],
                                summary: 'searchAllProductDetailBySkuId',
                                operationId: 'searchAllProductDetailBySkuIdUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/SearchStatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/profile/delete': {
                            delete: {
                                tags: ['profile-controller'],
                                summary: 'deleteProfileMenu',
                                operationId: 'deleteProfileMenuUsingDELETE',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMenu',
                                        in: 'query',
                                        description: 'idMenu',
                                        required: true,
                                        type: 'integer',
                                        format: 'int64'
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idPerfil',
                                        in: 'query',
                                        description: 'idPerfil',
                                        required: true,
                                        type: 'integer',
                                        format: 'int64'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '204': { description: 'No Content' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/profile/save': {
                            post: {
                                tags: ['profile-controller'],
                                summary: 'saveProfileMenu',
                                operationId: 'saveProfileMenuUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        in: 'body',
                                        name: 'profileVO',
                                        description: 'profileVO',
                                        required: true,
                                        schema: { $ref: '#/definitions/SaveProfileVO' }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/profile/search': {
                            get: {
                                tags: ['profile-controller'],
                                summary: 'getAllProfiles',
                                operationId: 'getAllProfilesUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/profile/user': {
                            get: {
                                tags: ['profile-controller'],
                                summary: 'getUserProfile',
                                operationId: 'getUserProfileUsingGET',
                                produces: ['*/*'],
                                parameters: [{ name: 'user', in: 'query', description: 'user', required: true, type: 'string' }],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/profile/user-multicatalog': {
                            get: {
                                tags: ['profile-controller'],
                                summary: 'getUserProfileMultiCatalog',
                                operationId: 'getUserProfileMultiCatalogUsingGET',
                                produces: ['*/*'],
                                parameters: [{ name: 'user', in: 'query', description: 'user', required: true, type: 'string' }],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/resetpass': {
                            post: {
                                tags: ['login-controller'],
                                summary: 'resetPassUser',
                                operationId: 'resetPassUserUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'login',
                                        description: 'login',
                                        required: true,
                                        schema: { $ref: '#/definitions/LoginDTO' }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/resetpasstoken': {
                            post: {
                                tags: ['login-controller'],
                                summary: 'resetPassTokenUser',
                                operationId: 'resetPassTokenUserUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'login',
                                        description: 'login',
                                        required: true,
                                        schema: { $ref: '#/definitions/LoginDTO' }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/searchpricecatalog': {
                            get: {
                                tags: ['price-controller'],
                                summary: 'searchPriceCatalog',
                                operationId: 'searchPriceCatalogUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/specification/createfacetvalue': {
                            get: {
                                tags: ['specification-controller'],
                                summary: 'createFacetValueSpecification',
                                operationId: 'createFacetValueSpecificationUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idCategory',
                                        in: 'query',
                                        description: 'idCategory',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idGroup',
                                        in: 'query',
                                        description: 'idGroup',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idSpecification',
                                        in: 'query',
                                        description: 'idSpecification',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/specification/createspecification': {
                            get: {
                                tags: ['specification-controller'],
                                summary: 'createspecification',
                                operationId: 'createspecificationUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idCategory',
                                        in: 'query',
                                        description: 'idCategory',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idGroup',
                                        in: 'query',
                                        description: 'idGroup',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idSpecification',
                                        in: 'query',
                                        description: 'idSpecification',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/specification/createvariantvalue': {
                            get: {
                                tags: ['specification-controller'],
                                summary: 'createVariantValueSpecification',
                                operationId: 'createVariantValueSpecificationUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idCategory',
                                        in: 'query',
                                        description: 'idCategory',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idGroup',
                                        in: 'query',
                                        description: 'idGroup',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idSpecification',
                                        in: 'query',
                                        description: 'idSpecification',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/specification/updatefacetvalue': {
                            get: {
                                tags: ['specification-controller'],
                                summary: 'updateFacetValue',
                                operationId: 'updateFacetValueUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idCategory',
                                        in: 'query',
                                        description: 'idCategory',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idGroup',
                                        in: 'query',
                                        description: 'idGroup',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idSpecification',
                                        in: 'query',
                                        description: 'idSpecification',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idValue',
                                        in: 'query',
                                        description: 'idValue',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/specification/updatevariantvalue': {
                            get: {
                                tags: ['specification-controller'],
                                summary: 'updateVariantValue',
                                operationId: 'updateVariantValueUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idCategory',
                                        in: 'query',
                                        description: 'idCategory',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idGroup',
                                        in: 'query',
                                        description: 'idGroup',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idSpecification',
                                        in: 'query',
                                        description: 'idSpecification',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idValue',
                                        in: 'query',
                                        description: 'idValue',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/status/info': {
                            get: {
                                tags: ['common-rest'],
                                summary: 'getInfo',
                                operationId: 'getInfoUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { type: 'string' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/statusApprovals': {
                            get: {
                                tags: ['status-approval-controller'],
                                summary: 'getList',
                                operationId: 'getListUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/supplier/create': {
                            post: {
                                tags: ['supplier-controller'],
                                summary: 'createSupplier',
                                operationId: 'createSupplierUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        in: 'body',
                                        name: 'providerDTO',
                                        description: 'providerDTO',
                                        required: true,
                                        schema: { $ref: '#/definitions/ProviderDTO' }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/supplier/search': {
                            get: {
                                tags: ['supplier-controller'],
                                summary: 'searchAllProviders',
                                operationId: 'searchAllProvidersUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'idProvider',
                                        in: 'query',
                                        description: 'idProvider',
                                        required: false,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    { name: 'nameProvider', in: 'query', description: 'nameProvider', required: false, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/tradepolicies': {
                            get: {
                                tags: ['trade-policies-controller'],
                                summary: 'searchTradePolicies',
                                operationId: 'searchTradePoliciesUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    { name: 'idMerchant', in: 'query', description: 'idMerchant', required: false, type: 'string' },
                                    { name: 'idPolicy', in: 'query', description: 'idPolicy', required: false, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/user/save': {
                            post: {
                                tags: ['user-controller'],
                                summary: 'saveUser',
                                operationId: 'saveUserUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        in: 'body',
                                        name: 'userVO',
                                        description: 'userVO',
                                        required: true,
                                        schema: { $ref: '#/definitions/UserVO' }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/user/searchall': {
                            get: {
                                tags: ['user-controller'],
                                summary: 'getUserProfile',
                                operationId: 'getUserProfileUsingGET_1',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/validatepass': {
                            post: {
                                tags: ['login-controller'],
                                summary: 'validateSupervisorPass',
                                operationId: 'validateSupervisorPassUsingPOST',
                                consumes: ['application/json'],
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        in: 'body',
                                        name: 'login',
                                        description: 'login',
                                        required: true,
                                        schema: { $ref: '#/definitions/LoginDTO' }
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '201': { description: 'Created' },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/loolu/api/warehouses': {
                            get: {
                                tags: ['warehouse-controller'],
                                summary: 'searchWarehouses',
                                operationId: 'searchWarehousesUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    { name: 'idMerchant', in: 'query', description: 'idMerchant', required: false, type: 'string' },
                                    { name: 'warehouses', in: 'query', description: 'warehouses', required: false, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/getHealthSkuMessages': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'getHealthSkuMessages',
                                operationId: 'getHealthSkuMessagesUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/getHealthSkuPercentage': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'getHealthSkuPercentage',
                                operationId: 'getHealthSkuPercentageUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/getHealthSkuTotals': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'getHealthSkuTotals',
                                operationId: 'getHealthSkuTotalsUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/getHealthSkuUpdates': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'getHealthSkuUpdates',
                                operationId: 'getHealthSkuUpdatesUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    { name: 'from', in: 'query', description: 'from', required: true, type: 'string' },
                                    { name: 'to', in: 'query', description: 'to', required: true, type: 'string' }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/getSkuBrandHealth': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'getSkuBrandHealth',
                                operationId: 'getSkuBrandHealthUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/getSkuCategoryHealth': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'getSkuCategoryHealth',
                                operationId: 'getSkuCategoryHealthUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/getSkuImagesHealth': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'getSkuImagesHealth',
                                operationId: 'getSkuImagesHealthUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/metrics/first-level': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'metricsLevel',
                                operationId: 'metricsLevelUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/metrics/image/score': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'metricsScoreImages',
                                operationId: 'metricsScoreImagesUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/metrics/images/second-level': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'metricsImagesLevelTwo',
                                operationId: 'metricsImagesLevelTwoUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/metrics/images/third-level': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'metricsImagessLevelThree',
                                operationId: 'metricsImagessLevelThreeUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'productId',
                                        in: 'query',
                                        description: 'productId',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/metrics/product/score': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'metricsScoreProduct',
                                operationId: 'metricsScoreProductUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/metrics/products/second-level': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'metricsProductsLevelTwo',
                                operationId: 'metricsProductsLevelTwoUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/metrics/products/third-level': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'metricsProductsLevelThree',
                                operationId: 'metricsProductsLevelThreeUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'productId',
                                        in: 'query',
                                        description: 'productId',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/metrics/specification/score': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'metricsScoreSpecification',
                                operationId: 'metricsScoreSpecificationUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/metrics/specifications/second-level': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'metricsSpecificationLevelTwo',
                                operationId: 'metricsSpecificationLevelTwoUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/metrics/specifications/third-level': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'metricsSpecificationsLevelThree',
                                operationId: 'metricsSpecificationsLevelThreeUsingGET',
                                produces: ['*/*'],
                                parameters: [
                                    {
                                        name: 'idMerchant',
                                        in: 'query',
                                        description: 'idMerchant',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    },
                                    {
                                        name: 'productId',
                                        in: 'query',
                                        description: 'productId',
                                        required: true,
                                        type: 'integer',
                                        format: 'int32'
                                    }
                                ],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/metrics/zero-level': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'metricsZeroLevel',
                                operationId: 'metricsZeroLevelUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/products/score': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'scoreProducts',
                                operationId: 'scoreProductsUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/search': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'getDash',
                                operationId: 'getDashUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        },
                        '/styrk/health-content/updateHealthContent': {
                            get: {
                                tags: ['health-controller'],
                                summary: 'healthManual',
                                operationId: 'healthManualUsingGET',
                                produces: ['*/*'],
                                responses: {
                                    '200': { description: 'OK', schema: { $ref: '#/definitions/StatusResponse' } },
                                    '401': { description: 'Unauthorized' },
                                    '403': { description: 'Forbidden' },
                                    '404': { description: 'Not Found' }
                                },
                                security: [{ JWT: ['global'] }],
                                deprecated: false
                            }
                        }
                    },
                    securityDefinitions: { JWT: { type: 'apiKey', name: 'Authorization', in: 'header' } },
                    definitions: {
                        AdditionalField: {
                            type: 'object',
                            properties: {
                                id: { type: 'integer', format: 'int32' },
                                keyName: { type: 'string' },
                                merchantId: { type: 'integer', format: 'int32' },
                                productId: { type: 'integer', format: 'int32' },
                                skuId: { type: 'integer', format: 'int32' },
                                value: { type: 'string' }
                            },
                            title: 'AdditionalField'
                        },
                        AdditionalFieldDTO: {
                            type: 'object',
                            properties: { field: { type: 'string' }, id: { type: 'integer', format: 'int32' }, value: { type: 'string' } },
                            title: 'AdditionalFieldDTO'
                        },
                        ApproveProductMulticatalog: {
                            type: 'object',
                            properties: {
                                merchantId: { type: 'integer', format: 'int32' },
                                productId: { type: 'integer', format: 'int32' },
                                skuId: { type: 'integer', format: 'int32' }
                            },
                            title: 'ApproveProductMulticatalog'
                        },
                        BrandSearchDTO: {
                            type: 'object',
                            properties: { isActive: { type: 'boolean' }, name: { type: 'string' } },
                            title: 'BrandSearchDTO'
                        },
                        ChangeLogDTO: {
                            type: 'object',
                            properties: {
                                dateChange: { type: 'string', format: 'date-time' },
                                idMerchant: { type: 'integer', format: 'int32' },
                                prodId: { type: 'string' },
                                productLog: { type: 'string' },
                                skuId: { type: 'string' },
                                userLog: { type: 'string' }
                            },
                            title: 'ChangeLogDTO'
                        },
                        CurrentLifecycleApprovalStatusVO: {
                            type: 'object',
                            properties: {
                                approved: { type: 'boolean' },
                                estatus: { type: 'string' },
                                idEstatus: { type: 'integer', format: 'int32' },
                                idMerchant: { type: 'integer', format: 'int32' },
                                idProfile: { type: 'integer', format: 'int32' },
                                isSaveButtonActive: { type: 'boolean' },
                                profile: { type: 'string' }
                            },
                            title: 'CurrentLifecycleApprovalStatusVO'
                        },
                        FormBrandMulticatalogDTO: {
                            type: 'object',
                            properties: {
                                brandData: { $ref: '#/definitions/VtexBrandDTO' },
                                fatherMerchant: { type: 'boolean' },
                                idMerchant: { type: 'integer', format: 'int32' }
                            },
                            title: 'FormBrandMulticatalogDTO'
                        },
                        FormCategoryMulticatalogDTO: {
                            type: 'object',
                            properties: {
                                categoryData: { $ref: '#/definitions/VtexCategoryDTO' },
                                fatherMerchant: { type: 'boolean' },
                                merchantId: { type: 'integer', format: 'int32' }
                            },
                            title: 'FormCategoryMulticatalogDTO'
                        },
                        InventoryDTO: {
                            type: 'object',
                            properties: {
                                idMerchant: { type: 'integer', format: 'int32' },
                                inventory: { type: 'integer', format: 'int32' },
                                itSent: { type: 'boolean' },
                                refID: { type: 'string' },
                                stockInVTEX: { type: 'integer', format: 'int32' },
                                wareHouseID: { type: 'string' }
                            },
                            title: 'InventoryDTO'
                        },
                        LifecycleApprovalProductVO: {
                            type: 'object',
                            properties: {
                                currentStatus: { $ref: '#/definitions/CurrentLifecycleApprovalStatusVO' },
                                estatus: { type: 'string' },
                                idEstatus: { type: 'integer', format: 'int32' },
                                idMerchant: { type: 'integer', format: 'int32' },
                                idProfile: { type: 'integer', format: 'int32' },
                                isSaveButtonActive: { type: 'boolean' },
                                lastStatus: { $ref: '#/definitions/CurrentLifecycleApprovalStatusVO' },
                                profile: { type: 'string' },
                                skuApprovalStatus: { type: 'array', items: { $ref: '#/definitions/LifecycleApprovalProductVO' } }
                            },
                            title: 'LifecycleApprovalProductVO'
                        },
                        LinkValSku: {
                            type: 'object',
                            properties: {
                                Id: { type: 'integer', format: 'int32' },
                                categoryId: { type: 'integer', format: 'int32' },
                                fieldId: { type: 'integer', format: 'int32' },
                                fieldValueId: { type: 'integer', format: 'int32' },
                                groupId: { type: 'integer', format: 'int32' },
                                id: { type: 'integer', format: 'int32' },
                                prodId: { type: 'integer', format: 'int64' },
                                productId: { type: 'integer', format: 'int64' },
                                skuId: { type: 'integer', format: 'int64' },
                                specificationId: { type: 'integer', format: 'int32' },
                                text: { type: 'string' },
                                valueId: { type: 'integer', format: 'int32' }
                            },
                            title: 'LinkValSku'
                        },
                        LoginDTO: {
                            type: 'object',
                            properties: {
                                email: { type: 'string' },
                                newPass: { type: 'string' },
                                pass: { type: 'string' },
                                tokenEmail: { type: 'string' },
                                user: { type: 'string' }
                            },
                            title: 'LoginDTO'
                        },
                        MenuVO: {
                            type: 'object',
                            properties: {
                                children: { type: 'array', items: { $ref: '#/definitions/MenuVO' } },
                                id: { type: 'integer', format: 'int64' },
                                idMenuPadre: { type: 'integer', format: 'int64' },
                                idPerfil: { type: 'integer', format: 'int64' },
                                type: { type: 'string' }
                            },
                            title: 'MenuVO'
                        },
                        Merchant: {
                            type: 'object',
                            properties: {
                                areaCode: { type: 'string' },
                                environment: { type: 'string' },
                                extension: { type: 'string' },
                                fatherMerchantId: { type: 'integer', format: 'int64' },
                                isfatherMerchantId: { type: 'integer', format: 'int64' },
                                merchantId: { type: 'integer', format: 'int64' },
                                multiCatalogMerchant: { $ref: '#/definitions/MerchantMulticatalogVO' },
                                name: { type: 'string' },
                                number: { type: 'string' },
                                status: { type: 'boolean' }
                            },
                            title: 'Merchant'
                        },
                        MerchantMulticatalogVO: {
                            type: 'object',
                            properties: {
                                areaCode: { type: 'string' },
                                environment: { type: 'string' },
                                extension: { type: 'string' },
                                fatherMerchantId: { type: 'integer', format: 'int64' },
                                isfatherMerchantId: { type: 'boolean' },
                                merchantId: { type: 'integer', format: 'int64' },
                                merchants: { type: 'array', items: { $ref: '#/definitions/Merchant' } },
                                name: { type: 'string' },
                                number: { type: 'string' },
                                status: { type: 'boolean' }
                            },
                            title: 'MerchantMulticatalogVO'
                        },
                        MerchantVO: {
                            type: 'object',
                            properties: {
                                appKey: { type: 'string' },
                                appToken: { type: 'string' },
                                country: { type: 'string' },
                                environmentName: { type: 'string' },
                                evaluation: { type: 'number' },
                                idMerchant: { type: 'integer', format: 'int32' },
                                imageVtexURL: { type: 'string' },
                                installToken: { type: 'string' },
                                international: { type: 'boolean' },
                                isPremium: { type: 'boolean' },
                                name: { type: 'string' },
                                rating: { type: 'integer', format: 'int32' },
                                status: { type: 'boolean' },
                                vtexURL: { type: 'string' }
                            },
                            title: 'MerchantVO'
                        },
                        ModelAndView: {
                            type: 'object',
                            properties: {
                                empty: { type: 'boolean' },
                                model: { type: 'object' },
                                modelMap: { type: 'object', additionalProperties: { type: 'object' } },
                                reference: { type: 'boolean' },
                                status: {
                                    type: 'string',
                                    enum: [
                                        '100 CONTINUE',
                                        '101 SWITCHING_PROTOCOLS',
                                        '102 PROCESSING',
                                        '103 CHECKPOINT',
                                        '200 OK',
                                        '201 CREATED',
                                        '202 ACCEPTED',
                                        '203 NON_AUTHORITATIVE_INFORMATION',
                                        '204 NO_CONTENT',
                                        '205 RESET_CONTENT',
                                        '206 PARTIAL_CONTENT',
                                        '207 MULTI_STATUS',
                                        '208 ALREADY_REPORTED',
                                        '226 IM_USED',
                                        '300 MULTIPLE_CHOICES',
                                        '301 MOVED_PERMANENTLY',
                                        '302 FOUND',
                                        '302 MOVED_TEMPORARILY',
                                        '303 SEE_OTHER',
                                        '304 NOT_MODIFIED',
                                        '305 USE_PROXY',
                                        '307 TEMPORARY_REDIRECT',
                                        '308 PERMANENT_REDIRECT',
                                        '400 BAD_REQUEST',
                                        '401 UNAUTHORIZED',
                                        '402 PAYMENT_REQUIRED',
                                        '403 FORBIDDEN',
                                        '404 NOT_FOUND',
                                        '405 METHOD_NOT_ALLOWED',
                                        '406 NOT_ACCEPTABLE',
                                        '407 PROXY_AUTHENTICATION_REQUIRED',
                                        '408 REQUEST_TIMEOUT',
                                        '409 CONFLICT',
                                        '410 GONE',
                                        '411 LENGTH_REQUIRED',
                                        '412 PRECONDITION_FAILED',
                                        '413 PAYLOAD_TOO_LARGE',
                                        '413 REQUEST_ENTITY_TOO_LARGE',
                                        '414 URI_TOO_LONG',
                                        '414 REQUEST_URI_TOO_LONG',
                                        '415 UNSUPPORTED_MEDIA_TYPE',
                                        '416 REQUESTED_RANGE_NOT_SATISFIABLE',
                                        '417 EXPECTATION_FAILED',
                                        '418 I_AM_A_TEAPOT',
                                        '419 INSUFFICIENT_SPACE_ON_RESOURCE',
                                        '420 METHOD_FAILURE',
                                        '421 DESTINATION_LOCKED',
                                        '422 UNPROCESSABLE_ENTITY',
                                        '423 LOCKED',
                                        '424 FAILED_DEPENDENCY',
                                        '426 UPGRADE_REQUIRED',
                                        '428 PRECONDITION_REQUIRED',
                                        '429 TOO_MANY_REQUESTS',
                                        '431 REQUEST_HEADER_FIELDS_TOO_LARGE',
                                        '451 UNAVAILABLE_FOR_LEGAL_REASONS',
                                        '500 INTERNAL_SERVER_ERROR',
                                        '501 NOT_IMPLEMENTED',
                                        '502 BAD_GATEWAY',
                                        '503 SERVICE_UNAVAILABLE',
                                        '504 GATEWAY_TIMEOUT',
                                        '505 HTTP_VERSION_NOT_SUPPORTED',
                                        '506 VARIANT_ALSO_NEGOTIATES',
                                        '507 INSUFFICIENT_STORAGE',
                                        '508 LOOP_DETECTED',
                                        '509 BANDWIDTH_LIMIT_EXCEEDED',
                                        '510 NOT_EXTENDED',
                                        '511 NETWORK_AUTHENTICATION_REQUIRED'
                                    ]
                                },
                                view: { $ref: '#/definitions/View' },
                                viewName: { type: 'string' }
                            },
                            title: 'ModelAndView'
                        },
                        PreventaVO: {
                            type: 'object',
                            properties: {
                                Fechafin: { type: 'string', example: 'dd-MM-yyyy HH:mm:ss' },
                                Fechainicio: { type: 'string', example: 'dd-MM-yyyy HH:mm:ss' },
                                Inventario: { type: 'integer', format: 'int32' },
                                Isactive: { type: 'boolean' }
                            },
                            title: 'PreventaVO'
                        },
                        PriceDTO: {
                            type: 'object',
                            properties: {
                                idMerchant: { type: 'integer', format: 'int32' },
                                itSent: { type: 'boolean' },
                                price: { type: 'number', format: 'double' },
                                priceDiscount: { type: 'number', format: 'double' },
                                refID: { type: 'string' },
                                tradePolicy: { type: 'integer', format: 'int32' }
                            },
                            title: 'PriceDTO'
                        },
                        ProductSpecification: {
                            type: 'object',
                            properties: {
                                FieldId: { type: 'integer', format: 'int64' },
                                FieldName: { type: 'string' },
                                FieldValueIds: { type: 'array', items: { type: 'object' } },
                                FieldValues: { type: 'array', items: { type: 'string' } }
                            },
                            title: 'ProductSpecification'
                        },
                        ProductSpecificationDTO: {
                            type: 'object',
                            properties: {
                                id: { type: 'integer', format: 'int64' },
                                name: { type: 'string' },
                                values: { type: 'array', items: { $ref: '#/definitions/ProductSpecificationValueDTO' } }
                            },
                            title: 'ProductSpecificationDTO'
                        },
                        ProductSpecificationValueDTO: {
                            type: 'object',
                            properties: { value: { type: 'string' }, valueId: { type: 'integer', format: 'int64' } },
                            title: 'ProductSpecificationValueDTO'
                        },
                        Profile: {
                            type: 'object',
                            properties: {
                                description: { type: 'string' },
                                id: { type: 'integer', format: 'int64' },
                                idStatus: { type: 'boolean' },
                                menuDetails: { type: 'array', items: { $ref: '#/definitions/MenuVO' } },
                                type: { type: 'string' }
                            },
                            title: 'Profile'
                        },
                        ProviderDTO: {
                            type: 'object',
                            properties: {
                                country: { type: 'string' },
                                idProvider: { type: 'integer', format: 'int32' },
                                name: { type: 'string' }
                            },
                            title: 'ProviderDTO'
                        },
                        ProviderVO: {
                            type: 'object',
                            properties: {
                                countryId: { type: 'string' },
                                idProvider: { type: 'integer', format: 'int32' },
                                name: { type: 'string' }
                            },
                            title: 'ProviderVO'
                        },
                        SaveLifecycleApprovalProductVO: {
                            type: 'object',
                            properties: {
                                approvalStatusId: { type: 'integer', format: 'int32' },
                                approved: { type: 'boolean' },
                                comment: { type: 'string' },
                                prodId: { type: 'integer', format: 'int32' },
                                rejectId: { type: 'integer', format: 'int32' },
                                skuId: { type: 'integer', format: 'int32' }
                            },
                            title: 'SaveLifecycleApprovalProductVO'
                        },
                        SaveProfileVO: {
                            type: 'object',
                            properties: {
                                description: { type: 'string' },
                                idPerfil: { type: 'integer', format: 'int64' },
                                idStatus: { type: 'boolean' },
                                menus: { type: 'array', items: { type: 'integer', format: 'int64' } },
                                type: { type: 'string' }
                            },
                            title: 'SaveProfileVO'
                        },
                        SearchStatusResponse: {
                            type: 'object',
                            properties: {
                                code: { type: 'integer', format: 'int32' },
                                message: { type: 'string' },
                                response: { type: 'object' },
                                status: { type: 'string' },
                                totalItems: { type: 'integer', format: 'int32' },
                                totalPages: { type: 'integer', format: 'int32' }
                            },
                            title: 'SearchStatusResponse'
                        },
                        SkuSeller: {
                            type: 'object',
                            properties: {
                                FreightCommissionPercentage: { type: 'integer', format: 'int64' },
                                IsActive: { type: 'boolean' },
                                ProductCommissionPercentage: { type: 'integer', format: 'int64' },
                                SellerId: { type: 'string' },
                                SellerStockKeepingUnitId: { type: 'string' },
                                StockKeepingUnitId: { type: 'integer', format: 'int64' }
                            },
                            title: 'SkuSeller'
                        },
                        SobrePedidoVO: {
                            type: 'object',
                            properties: {
                                Fechafin: { type: 'string', example: 'dd-MM-yyyy hh:mm:ss' },
                                Fechainicio: { type: 'string', example: 'dd-MM-yyyy hh:mm:ss' },
                                Inventario: { type: 'integer', format: 'int32' },
                                Isactive: { type: 'boolean' }
                            },
                            title: 'SobrePedidoVO'
                        },
                        StatusResponse: {
                            type: 'object',
                            properties: {
                                code: { type: 'integer', format: 'int32' },
                                message: { type: 'string' },
                                response: { type: 'object' },
                                status: { type: 'string' }
                            },
                            title: 'StatusResponse'
                        },
                        TradePoliciesVO: {
                            type: 'object',
                            properties: {
                                idPolicy: { type: 'integer', format: 'int32' },
                                isSelected: { type: 'boolean' },
                                tradePolicyName: { type: 'string' }
                            },
                            title: 'TradePoliciesVO'
                        },
                        UserVO: {
                            type: 'object',
                            properties: {
                                dateCreated: { type: 'string', format: 'date-time' },
                                dateLastUpdate: { type: 'string', format: 'date-time' },
                                email: { type: 'string' },
                                employeNumber: { type: 'integer', format: 'int64' },
                                expiredtoken: { type: 'string', format: 'date-time' },
                                firstName: { type: 'string' },
                                id: { type: 'integer', format: 'int64' },
                                idApprovalProfile: { type: 'integer', format: 'int32' },
                                lastLogin: { type: 'string', format: 'date-time' },
                                lastName: { type: 'string' },
                                merchant: { $ref: '#/definitions/Merchant' },
                                pass: { type: 'string' },
                                phoneNumber: { type: 'string' },
                                profile: { $ref: '#/definitions/Profile' },
                                provider: { $ref: '#/definitions/ProviderVO' },
                                statementDescriptor: { type: 'string' },
                                status: { type: 'integer', format: 'int64' },
                                statusType: { type: 'string' },
                                token: { type: 'string' },
                                user: { type: 'string' }
                            },
                            title: 'UserVO'
                        },
                        View: { type: 'object', properties: { contentType: { type: 'string' } }, title: 'View' },
                        VtexBrandDTO: {
                            type: 'object',
                            properties: {
                                idBrand: { type: 'integer', format: 'int64' },
                                idMerchant: { type: 'integer', format: 'int64' },
                                imageUrl: { type: 'string' },
                                isActive: { type: 'boolean' },
                                masterBrandId: { type: 'integer', format: 'int64' },
                                metaTagDescription: { type: 'string' },
                                name: { type: 'string' },
                                title: { type: 'string' }
                            },
                            title: 'VtexBrandDTO'
                        },
                        VtexCategoryDTO: {
                            type: 'object',
                            properties: {
                                activeStoreFrontLink: { type: 'boolean' },
                                adWordsRemarketingCode: { type: 'string' },
                                children: { type: 'array', items: { $ref: '#/definitions/VtexCategoryDTO' } },
                                description: { type: 'string' },
                                fatherCategoryId: { type: 'integer', format: 'int32' },
                                globalCategoryId: { type: 'integer', format: 'int32' },
                                hasChildren: { type: 'boolean' },
                                id: { type: 'integer', format: 'int64' },
                                isActive: { type: 'boolean' },
                                key: { type: 'integer', format: 'int64' },
                                keywords: { type: 'string' },
                                label: { type: 'string' },
                                lomadeeCampaignCode: { type: 'string' },
                                masterCategoryId: { type: 'integer', format: 'int64' },
                                name: { type: 'string' },
                                numberChildren: { type: 'integer', format: 'int32' },
                                score: { type: 'integer', format: 'int32' },
                                showBrandFilter: { type: 'boolean' },
                                showInStoreFront: { type: 'boolean' },
                                stockKeepingUnitSelectionMode: { type: 'string' },
                                title: { type: 'string' }
                            },
                            title: 'VtexCategoryDTO'
                        },
                        VtexInventoryVO: {
                            type: 'object',
                            properties: {
                                idMerchant: { type: 'integer', format: 'int32' },
                                inventory: { type: 'integer', format: 'int32' },
                                itSent: { type: 'boolean' },
                                skuId: { type: 'string' },
                                stockInVTEX: { type: 'integer', format: 'int32' },
                                wareHouseID: { type: 'string' }
                            },
                            title: 'VtexInventoryVO'
                        },
                        VtexPricesVO: {
                            type: 'object',
                            properties: {
                                idMerchant: { type: 'integer', format: 'int32' },
                                itSent: { type: 'boolean' },
                                name: { type: 'string' },
                                price: { type: 'number', format: 'double' },
                                priceDiscount: { type: 'number', format: 'double' },
                                skuId: { type: 'string' },
                                tradePolicy: { type: 'integer', format: 'int32' }
                            },
                            title: 'VtexPricesVO'
                        },
                        VtexProductSkuSearchDetailVO: {
                            type: 'object',
                            properties: {
                                additionalFields: { type: 'array', items: { $ref: '#/definitions/AdditionalFieldDTO' } },
                                brandId: { type: 'integer', format: 'int32' },
                                brandName: { type: 'string' },
                                categoryId: { type: 'integer', format: 'int32' },
                                categoryName: { type: 'string' },
                                cscIdentification: { type: 'object' },
                                departmentId: { type: 'integer', format: 'int32' },
                                description: { type: 'string' },
                                descriptionShort: { type: 'string' },
                                giftCardRecharge: { type: 'boolean' },
                                hiddenTradePolicies: { type: 'string' },
                                imageUrl: { type: 'string' },
                                informationSource: { type: 'object' },
                                inventoried: { type: 'boolean' },
                                isActive: { type: 'boolean' },
                                isEcommerce: { type: 'boolean' },
                                isVisible: { type: 'boolean' },
                                isVtexCreated: { type: 'boolean' },
                                isfatherMerchantId: { type: 'boolean' },
                                keyWords: { type: 'string' },
                                kit: { type: 'boolean' },
                                lastDateUpdate: { type: 'string', format: 'date-time' },
                                linkId: { type: 'string' },
                                manufacturerCode: { type: 'string' },
                                merchantId: { type: 'integer', format: 'int32' },
                                merchantName: { type: 'string' },
                                metaTagDescription: { type: 'string' },
                                nameComplete: { type: 'string' },
                                presale: { type: 'boolean' },
                                preventa: { $ref: '#/definitions/PreventaVO' },
                                productDescription: { type: 'string' },
                                productGlobalCategoryID: { type: 'integer', format: 'int32' },
                                productID: { type: 'string' },
                                productName: { type: 'string' },
                                productRefID: { type: 'string' },
                                productSpecifications: { type: 'array', items: { $ref: '#/definitions/ProductSpecificationDTO' } },
                                productStatus: { type: 'string' },
                                productVtexID: { type: 'integer', format: 'int32' },
                                provider: { $ref: '#/definitions/ProviderVO' },
                                releaseDate: { type: 'string', example: 'dd-MM-yyyy' },
                                showWithoutStock: { type: 'boolean' },
                                sku: { $ref: '#/definitions/VtexSkuSearchDetailVO' },
                                skuName: { type: 'string' },
                                skus: { type: 'array', items: { $ref: '#/definitions/VtexSkuSearchDetailVO' } },
                                sobrePedido: { $ref: '#/definitions/SobrePedidoVO' },
                                syncStatusVTEX: { type: 'string' },
                                taxCode: { type: 'string' },
                                title: { type: 'string' },
                                tradePolicies: { type: 'array', items: { $ref: '#/definitions/TradePoliciesVO' } },
                                transported: { type: 'boolean' },
                                userUpdate: { type: 'string' }
                            },
                            title: 'VtexProductSkuSearchDetailVO'
                        },
                        VtexSkuImageVO: {
                            type: 'object',
                            properties: {
                                IdImage: { type: 'integer', format: 'int32' },
                                IdMerchant: { type: 'integer', format: 'int32' },
                                IdVtex: { type: 'integer', format: 'int64' },
                                ImageURL: { type: 'string' },
                                IsMain: { type: 'boolean' },
                                ItSent: { type: 'boolean' },
                                Label: { type: 'string' },
                                SkuID: { type: 'string' },
                                Text: { type: 'string' },
                                imageName: { type: 'string' },
                                text: { type: 'string' }
                            },
                            title: 'VtexSkuImageVO'
                        },
                        VtexSkuSearchDetailVO: {
                            type: 'object',
                            properties: {
                                additionalFields: { type: 'array', items: { $ref: '#/definitions/AdditionalFieldDTO' } },
                                approvalStatus: { $ref: '#/definitions/LifecycleApprovalProductVO' },
                                commercialConditionId: { type: 'integer', format: 'int32' },
                                creationDate: { type: 'string' },
                                cubicWeight: { type: 'number' },
                                ean: { type: 'string' },
                                estimatedDateArrival: { type: 'string' },
                                height: { type: 'number' },
                                images: { type: 'array', items: { $ref: '#/definitions/VtexSkuImageVO' } },
                                inventory: { type: 'array', items: { $ref: '#/definitions/VtexInventoryVO' } },
                                isActive: { type: 'boolean' },
                                isKit: { type: 'boolean' },
                                isVtexCreated: { type: 'boolean' },
                                kitItensSellApart: { type: 'boolean' },
                                length: { type: 'number' },
                                manufacturerCode: { type: 'string' },
                                measurementUnit: { type: 'string' },
                                name: { type: 'string' },
                                packagedHeight: { type: 'number' },
                                packagedLength: { type: 'number' },
                                packagedWeightKg: { type: 'number' },
                                packagedWidth: { type: 'number' },
                                prices: { type: 'array', items: { $ref: '#/definitions/VtexPricesVO' } },
                                productClustersIDS: { type: 'string' },
                                productID: { type: 'string' },
                                productSpecifications: { type: 'array', items: { $ref: '#/definitions/ProductSpecification' } },
                                refID: { type: 'string' },
                                rewardValue: { type: 'number' },
                                sellerId: { type: 'string' },
                                skuID: { type: 'string' },
                                skuSellers: { type: 'array', items: { $ref: '#/definitions/SkuSeller' } },
                                skuSpecifications: { type: 'array', items: { $ref: '#/definitions/ProductSpecificationDTO' } },
                                unitMultiplier: { type: 'number' },
                                videos: { type: 'array', items: { type: 'object' } },
                                vtexSkuID: { type: 'integer', format: 'int32' },
                                weightKg: { type: 'number' },
                                width: { type: 'number' }
                            },
                            title: 'VtexSkuSearchDetailVO'
                        }
                    }
                }}
                options={{
                    disableSearch: true,
                    theme: {
                        colors: {
                            primary: {
                                main: theme.palette.primary.main,
                                dark: theme.palette.primary.dark,
                                light: theme.palette.primary.light,
                                contrastText: theme.palette.primary.contrastText
                            },
                            success: {
                                main: theme.palette.success.main,
                                dark: theme.palette.success.dark,
                                light: theme.palette.success.light,
                                contrastText: theme.palette.success.contrastText
                            },
                            error: {
                                main: theme.palette.error.main,
                                dark: theme.palette.error.dark,
                                light: theme.palette.error.light,
                                contrastText: theme.palette.error.contrastText
                            },
                            warning: {
                                main: theme.palette.warning.main,
                                dark: theme.palette.warning.dark,
                                light: theme.palette.warning.light,
                                contrastText: theme.palette.warning.contrastText
                            },
                            text: {
                                primary: theme.palette.text.primary,
                                secondary: theme.palette.text.secondary
                            },
                            border: {
                                light: theme.palette.divider,
                                dark: theme.palette.divider
                            },
                            gray: {
                                50: '#111523',
                                100: '#111523'
                            }
                        },
                        typography: {
                            fontSize: `${theme.typography.fontSize}px`,
                            fontFamily: theme.typography.fontFamily,
                            fontWeightLight: theme.typography.fontWeightLight?.toString(),
                            fontWeightRegular: theme.typography.fontWeightRegular?.toString(),
                            fontWeightBold: theme.typography.fontWeightBold?.toString(),
                            code: {
                                fontSize: `${theme.typography.fontSize}px`,
                                fontFamily: 'monospace'
                            },
                            headings: {
                                fontFamily: theme.typography.fontFamily,
                                fontWeight: theme.typography.fontWeightBold?.toString()
                            },
                            links: {
                                color: theme.palette.text.secondary
                            }
                        },
                        sidebar: {
                            backgroundColor: theme.palette.background.paper,
                            textColor: theme.palette.text.secondary,
                            activeTextColor: theme.palette.text.primary
                        },
                        schema: {
                            typeTitleColor: theme.palette.secondary.dark
                        },
                        rightPanel: {
                            backgroundColor: theme.palette.background.paper,
                            servers: {
                                overlay: { backgroundColor: theme.palette.background.paper },
                                url: { backgroundColor: theme.palette.background.paper }
                            }
                        }
                    }
                }}
            />
        </>
    );
};

export default DocsPage;
